import AdminOIDCSettings from './AdminOIDCSettings';
export default AdminOIDCSettings;
